import ApiService from './ApiService';

export default class ContentSettingApi extends ApiService {
    constructor() {
        super('');
    }

    // #region CMS
    createOrUpdateCompanyIntroduction(payload) {
        return this.put('system/content-settings/aboutus', payload);
    }

    getCompanyIntroduction() {
        return this.get('system/content-settings/aboutus');
    }

    createOrUpdatePrivacyPolicy(payload) {
        return this.put('system/content-settings/privacy_policy', payload);
    }

    getPrivacyPolicy() {
        return this.get('system/content-settings/privacy_policy');
    }

    createOrUpdateTermsAndConditions(payload) {
        return this.put('system/content-settings/terms', payload);
    }

    getTermsAndConditions() {
        return this.get('system/content-settings/terms');
    }

    createOrUpdateSpecialCommercial(payload) {
        return this.put('system/content-settings/specifiedtrade', payload);
    }

    getSpecialCommercial() {
        return this.get('system/content-settings/specifiedtrade');
    }

    createOrUpdateCancellationPolicy(payload) {
        return this.put('system/content-settings/cancelpolicy', payload);
    }

    getCancellationPolicy() {
        return this.get('system/content-settings/cancelpolicy');
    }

    // #endregion

    // #region Enduser
    getCompanyIntroductionEnduser(payload) {
        return this.get('content-settings/aboutus', payload);
    }

    getPrivacyPolicyEnduser(payload) {
        return this.get('content-settings/privacy_policy', payload);
    }

    getTermsAndConditionsEnduser(payload) {
        return this.get('content-settings/terms', payload);
    }

    getSpecialCommercialEnduser(payload) {
        return this.get('content-settings/specifiedtrade', payload);
    }

    getCancellationPolicyEnduser(payload) {
        return this.get('content-settings/cancelpolicy', payload);
    }
    // #endregion
}
